// This function checks if the user is an admin based on their email

import { getConfig } from '.';

const allowedList = getConfig('siteAdminEmails');
// window is not available when this module is loaded by the SSR bundle in Node.js.
// In that context no user is ever admin, so we fall back to an empty string.
const queryString = typeof window !== 'undefined' ? window.location.search : '';
const urlParams = new URLSearchParams(queryString);

const isAdminUser = (userEmail?: string) => {
    let isAdmin = false;
    if (allowedList && allowedList.length > 0 && userEmail && urlParams.has('kingcharles')) {
        isAdmin = allowedList.some((email: string) => userEmail.toLowerCase().includes(email));
    }
    return isAdmin;
};

export default isAdminUser;
